import React from "react";
import withShipment from "../../../withShipment";
import {
    ADD_DOCUMENT, BACK,
    CANCEL,
    FTL_DOCUMENT_TYPES,
    FTL_PAGES,
    FTL_SETUP_HELPER_TEXT,
    FTL_SETUP_TABLE_HEADERS,
    FULL_TRUCKLOAD, FULL_TRUCKLOAD_SETTINGS,
    REMOVE_DOCUMENT,
    SAVE
} from "../constants";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import SaveIcon from '@mui/icons-material/Save';
import IconButton from "@material-ui/core/IconButton";
import {getByteArray} from "../../global/constants";
import FileUpload from "../../global/FileUpload";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import {Button, Table, TableRow, TextField, Tooltip} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import Chip from "@material-ui/core/Chip";
import {listAvailableLocations, listPackages, listProducts, listSuppliers} from "../../../redux/actions/settings";
import {
    availableLocationsSelector,
    packagesSelector,
    productsSelector,
    suppliersSelector
} from "../../../redux/selectors/settings";
import {
    fetchFullTruckloadSettings,
    saveFullTruckloadSettings,
    listFullTruckloadSignatures,
    clearFtlSettingSaveResponseMessage
} from "../../../redux/actions/fullTruckload";
import TableCell from "@material-ui/core/TableCell";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import Divider from "@material-ui/core/Divider";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
// import styling
import { Tabs, Tab } from '@material-ui/core';
import './FullTruckloadSetup.css'
import {
    fullTruckloadSettingsSelector,
    fullTruckloadSignaturesSelector,
    saveFtlSettingResponseMessageSelector
} from "../../../redux/selectors/fullTruckload";
import DragAndDrop from "../../global/Dnd/DragAndDrop";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import {ERROR, SUCCESS} from "../../shipments/constants";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";

class FullTruckloadSetup extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            attachments: [],
            billOfLading: {},
            deletedAttachments: [],
            deletingRowIndex: -1,
            settingsChanged: false,
            selectedTab: 0,
            suppliers:[],
            feedbackBarOpen: false,
            errorMessage:"",
            errorFeedbackBarOpen: false,
        }
    }

    componentDidMount() {
        Promise.all([
            this.props.listProducts(),
            this.props.listPackages(),
            this.props.fetchFullTruckloadSettings(),
            this.props.listAvailableLocations(),
            this.props.listFullTruckloadSignatures(),
            this.props.listSuppliers(),
        ]).catch(err => console.error(err));
        if (this.props.fullTruckloadSettings) {
            this.setState({
                attachments: this.props.fullTruckloadSettings.attachments ? [...this.props.fullTruckloadSettings.attachments] : [],
                billOfLading: this.props.fullTruckloadSettings.billOfLading ? {...this.props.fullTruckloadSettings.billOfLading} : {}
            })
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.fullTruckloadSettings !== prevProps.fullTruckloadSettings) {
            this.setState({
            attachments: this.props.fullTruckloadSettings.attachments ? [...this.props.fullTruckloadSettings.attachments] : [],
            billOfLading: this.props.fullTruckloadSettings.billOfLading ? {...this.props.fullTruckloadSettings.billOfLading} : {}
            })
        }
        if (this.props.suppliers !== prevProps.suppliers) {
            let suppliers = this.props.suppliers.map(supplier => ({
                name: supplier.name,
                supplierId: supplier.supplierId
            }));
            this.setState({
                suppliers: suppliers
            })
        }
        if (prevProps.responseMessage !== this.props.responseMessage && this.props.responseMessage!=="") {
            this.setState({
                feedbackBarOpen: true
            })
        }
    }

    handleTabChange = (event, newValue) => {
        this.setState({ selectedTab: newValue });
    };

    updateAttachmentShortcodes = (index, newShortcodes) => {
        let newAttachments = this.state.attachments
        newAttachments[index].shortcodes = newShortcodes
        this.setState({
            attachments: newAttachments,
            settingsChanged: true
        })
    }

    updateAttachmentType = (index, type) => {
        let newAttachments = this.state.attachments
        newAttachments[index].type = type
        this.setState({
            attachments: newAttachments,
            settingsChanged: true
        })
    }

    updateSupplier = (index, value) => {
        let newAttachments = [...this.state.attachments]
        newAttachments[index].supplierName = value?.name
        newAttachments[index].supplierId = value?.supplierId
        this.setState({
            attachments: newAttachments,
            settingsChanged: true
        })
    }

    updateLocation = (index, value) => {
        let newAttachments = this.state.attachments
        newAttachments[index].shipAddressId = value?.shipAddressId ?? null
        this.setState({
            attachments: newAttachments,
            settingsChanged: true
        })
    }

    handleSignatureChange = (attachment, value) => {
        const attachmentCopy = this.state.attachments.map((curAttachment) => {
            if (attachment.file.displayName !== curAttachment.file.displayName) {
                return curAttachment;
            } else {
                return { ...curAttachment, signature: value };
            }
        });
        this.setState({
            attachments: attachmentCopy,
            settingsChanged: true,
        });
    }

    addAttachment = () => {
        let newAttachments = this.state.attachments
        newAttachments.push({
            file: {},
            shortcodes: [],
            type: "",
            requiredForDomestic: false,
            requiredForInternational: false,
            sequence: ""
        })
        this.setState({
            attachments: newAttachments,
            settingsChanged: true
        })
    }

    deleteAttachment = (index) => {
        let newAttachments = this.state.attachments
        let newDeletedAttachments = this.state.deletedAttachments
        newDeletedAttachments.push(newAttachments[index])
        newAttachments.splice(index, 1)
        this.setState({
            attachments: newAttachments,
            deletedAttachments: newDeletedAttachments,
            deletingRowIndex: -1,
            settingsChanged: true
        })
    }

    getFormattedGeneralFileObject = (file) => {
        return { localURL: URL.createObjectURL(file), displayName: file.name, byteArray: getByteArray(file), type: file.type }

    }

    handleAddBillOfLading = (file) => {
        let newFile = this.getFormattedGeneralFileObject(file)
        this.setState({
            billOfLading: newFile,
            settingsChanged: true
        })
    }

    handleGeneralFileAdd = (file, index) => {
        let newAttachments = this.state.attachments
        // replace new file with previous file
        if (newAttachments[index].file?.displayName && !newAttachments[index].file?.byteArray) {
            let deletedAttachment = JSON.parse(JSON.stringify(newAttachments[index]));
            this.setState({
                deletedAttachments: [...this.state.deletedAttachments, deletedAttachment]
            });
        }
        newAttachments[index].file = this.getFormattedGeneralFileObject(file)
        this.setState({
            attachments: newAttachments,
            settingsChanged: true
        });
    }

    handleGeneralFileDelete = (file, fileIndex, index) => {
        let newAttachments = this.state.attachments
        // make a deep copy
        let deletedAttachment = JSON.parse(JSON.stringify(newAttachments[index]));
        newAttachments[index].file = {}
        this.setState({
            deletedAttachments: [...this.state.deletedAttachments, deletedAttachment],
            attachments: newAttachments,
            settingsChanged: true,
        })
    }

    toggleRequiredForDomestic = (index) => {
        let newAttachments = this.state.attachments
        newAttachments[index].requiredForDomestic = !newAttachments[index].requiredForDomestic

        this.setState({
            attachments: newAttachments,
            settingsChanged: true
        })
    }

    toggleRequiredForInternational = (index) => {
        let newAttachments = this.state.attachments
        newAttachments[index].requiredForInternational = !newAttachments[index].requiredForInternational

        this.setState({
            attachments: newAttachments,
            settingsChanged: true
        })
    }

    updateSequence = (index, value) => {
        if (value !== "" && !/^[1-9]\d*$/.test(value)) {
            return
        }
        let newAttachments = this.state.attachments
        newAttachments[index].sequence = value

        this.setState({
            attachments: newAttachments,
            settingsChanged: true
        })
    }

    saveSettings = () => {
        let newSettings = {
            attachments: this.state.attachments,
            billOfLading: this.state.billOfLading,
            deletedAttachments: this.state.deletedAttachments.filter(attachment => attachment.file?.displayName)
        }
        this.props.saveFullTruckloadSettings(newSettings, () => this.setState({ settingsChanged: false }))
    }

    handleAttachmentsOrderChange = (attachments) => {
        let newOrderedAttachments = []
        for (let i = 0; i < attachments.length; i++) {
            if (this.state.attachments.indexOf(attachments[i]) !== -1) {
                newOrderedAttachments.push(attachments[i])
            }
        }
        this.setState({
            attachments: newOrderedAttachments,
            settingsChanged: true
        })
    }

    closeFeedbackBar = () => {
        this.setState({
            feedbackBarOpen: false
        })
        this.props.clearFtlSettingSaveResponseMessage()
    }

    closeErrorFeedbackBar = () => {
        this.setState({
            errorFeedbackBarOpen: false,
            errorMessage: "",
        })
    }


    render() {
        const productShortcodes = this.props.products?.map(p => p.shortcode) || []
        const packageShortcodes = this.props.packages?.map(p => p.shortcode) || []

        const shortcodes = [...new Set([...productShortcodes, ...packageShortcodes])]
            .filter(Boolean) // remove undefined/null
            .sort((a, b) => a.localeCompare(b))

        return (
            <React.Fragment>
                <ErrorFeedbackBar/>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    severity={SUCCESS}
                    message={this.props.responseMessage}
                    handleClose={this.closeFeedbackBar}
                />
                <FeedbackBar
                    open={this.state.errorFeedbackBarOpen}
                    severity={ERROR}
                    message={this.state.errorMessage}
                    handleClose={this.closeErrorFeedbackBar}
                />
                <TopToolbar
                    pageName={FULL_TRUCKLOAD_SETTINGS}
                    menuItems={[
                        {title: BACK, icon: <KeyboardBackspaceIcon/>, onClick: () => {
                            this.props.setCurrentPage(FTL_PAGES.TABLE)
                        }},
                        {title: SAVE, icon: <SaveIcon/>, onClick: () => {
                                this.saveSettings()
                            }, disabled: !this.state.settingsChanged}
                    ]}
                />

                <Tabs
                    value={this.props.selectedTab}
                    onChange={(event, value) => this.props.handleTabChange(value)}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label= {FTL_PAGES.SETUP} />
                    <Tab label= {FTL_PAGES.CUSTOMS_BROKERS} />
                    <Tab label= {FTL_PAGES.SIGNATURES} />
                    <Tab label= {FTL_PAGES.NOA_PORTS}/>
                </Tabs>

                <div>
                    <div style={{margin: "25px"}}>
                        {FTL_SETUP_HELPER_TEXT}
                    </div>



                    <div style={{overflowX: "auto", margin: "0 25px"}}>
                    <Table style={{width: "100%", minWidth: "1600px"}}>
                        <TableRow className="table">
                            <TableCell colSpan={9}>
                                {/* same layout as the document rows below so each label sits over its field */}
                                <div style={{display: "flex", alignItems: "center", margin: "0 6px"}}>
                                    <IconButton style={{visibility: "hidden"}}>
                                        <RemoveCircleIcon fontSize='small'/>
                                    </IconButton>
                                    {FTL_SETUP_TABLE_HEADERS.map((headCell) => (
                                        <div key={headCell.label}
                                             style={{textAlign: "center", fontWeight: "bold", width: headCell.width, paddingLeft: headCell.paddingLeft, minWidth: 0}}>
                                            {headCell.label}
                                        </div>
                                    ))}
                                </div>
                            </TableCell>
                        </TableRow>
                        <TableRow className="table">
                            <TableCell style={{ textAlign: "center" }} colSpan={9}>
                                <div style={{
                                    justifyContent: "center",
                                    marginRight: "auto",
                                    marginLeft: "auto",
                                }}>
                                    <DndProvider backend={HTML5Backend}>
                                        <DragAndDrop
                                            cards={this.state.attachments}
                                            handleTableDisplayChange = {(attachments) => this.handleAttachmentsOrderChange(attachments)}
                                            items = {this.state.attachments.map((attachment, index) => {
                                                return (
                                                    {
                                                        id: attachment.id,
                                                        component:
                                                        <div style={{
                                                            border: "1px solid grey",
                                                            margin: "5px",
                                                            marginBottom: "20px",
                                                            borderRadius: "10px",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            minHeight: "145px"
                                                        }}>
                                                            <div style={{display: "flex", marginTop: "20px"}}>
                                                                <Tooltip title={REMOVE_DOCUMENT}>
                                                                    <IconButton onClick={() => this.deleteAttachment(index)}>
                                                                        <RemoveCircleIcon
                                                                            fontSize='small'
                                                                            color='error'
                                                                        />

                                                                    </IconButton>
                                                                </Tooltip>
                                                                <div style={{borderRadius: "1px", width:"14%", paddingLeft: "1.8%"}}>
                                                                    <Autocomplete
                                                                        className="ftl-item-shortcode-field"
                                                                        multiple
                                                                        disableCloseOnSelect
                                                                        options={shortcodes}
                                                                        getOptionLabel={(entry) => entry || ""}
                                                                        renderTags={(value, getTagProps) => {
                                                                            if (value.length === 0) return null
                                                                            return (
                                                                                <Chip
                                                                                    variant="outlined"
                                                                                    size="small"
                                                                                    style={{
                                                                                        borderColor: "#acd685",
                                                                                        margin: "1px 6px 1px 0",
                                                                                        fontSize: "12px"
                                                                                    }}
                                                                                    label={value.length > 1 ? `${value[0]}, ...` : value[0]}
                                                                                />
                                                                            )
                                                                        }
                                                                        }
                                                                        renderOption={(option, { selected }) => (
                                                                            <React.Fragment>
                                                                                <Checkbox
                                                                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                                                    style={{ marginRight: 8 }}
                                                                                    checked={selected}
                                                                                />
                                                                                {option}
                                                                            </React.Fragment>
                                                                        )}
                                                                        autoHighlight={true}
                                                                        blurOnSelect={false}
                                                                        value={attachment.shortcodes}
                                                                        onChange={(event, value) => this.updateAttachmentShortcodes(index, value)}
                                                                        renderInput={(params) =>
                                                                            <TextField
                                                                                {...params}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant="outlined"
                                                                                name="shortcodes"
                                                                                InputProps={{...params.InputProps, style: {flexWrap: "nowrap"}}}
                                                                            />
                                                                        }
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"16%"}}>
                                                                    <Autocomplete
                                                                        className="ftl-item-shortcode-field"
                                                                        options={this.state.suppliers}
                                                                        getOptionLabel={(entry) => entry.name || ""}
                                                                        autoHighlight={true}
                                                                        blurOnSelect={false}
                                                                        value={attachment?.supplierId
                                                                            ? this.state.suppliers.find(supplier => supplier.supplierId === attachment.supplierId) || null
                                                                            : null}
                                                                        onChange={(event, value) => this.updateSupplier(index, value)}
                                                                        renderInput={(params) =>
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                                name="type"
                                                                                InputLabelProps={{ shrink: true }}
                                                                            />
                                                                        }
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"18%"}}>
                                                                    <Autocomplete
                                                                        className="ftl-item-shortcode-field"
                                                                        options={[...FTL_DOCUMENT_TYPES].sort((a, b) => a.localeCompare(b))}
                                                                        getOptionLabel={(entry) => entry || ""}
                                                                        autoHighlight={true}
                                                                        blurOnSelect={false}
                                                                        value={attachment.type}
                                                                        onChange={(event, value) => this.updateAttachmentType(index, value)}
                                                                        renderInput={(params) =>
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                                name="type"
                                                                                InputLabelProps={{ shrink: true }}
                                                                            />
                                                                        }
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"13%"}}>
                                                                    <Autocomplete
                                                                        className="ftl-item-shortcode-field"
                                                                        options={this.props.availableLocations}
                                                                        getOptionLabel={(entry) => entry.name || ""}
                                                                        autoHighlight={true}
                                                                        blurOnSelect={false}
                                                                        value={this.props.availableLocations.find(loc => loc.shipAddressId === attachment.shipAddressId) || null}
                                                                        onChange={(event, value) => this.updateLocation(index, value)}
                                                                        renderInput={(params) =>
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                                name="type"
                                                                                InputLabelProps={{ shrink: true }}
                                                                            />
                                                                        }
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"13%"}}>
                                                                    <Autocomplete
                                                                        className="ftl-item-shortcode-field"
                                                                        value={attachment.signature || ''}  // Ensure value is controlled
                                                                        InputLabelProps={{ shrink: true }}
                                                                        options={Array.isArray(this.props.signatures) ? this.props.signatures : []}
                                                                        getOptionLabel={(option) => (option && option.name) || ""}
                                                                        autoHighlight
                                                                        onChange={(event, value) => this.handleSignatureChange(attachment, value)}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant="outlined"
                                                                                name="signature"
                                                                            />
                                                                        )}
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"7.8%", textAlign: "center"}}>
                                                                    <Checkbox
                                                                        checked={attachment.requiredForDomestic}
                                                                        onChange={() => this.toggleRequiredForDomestic(index)}
                                                                        name="requiredForDomestic"
                                                                        style={{ color: '#acd685' }}
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"7.8%", textAlign: "center"}}>
                                                                    <Checkbox
                                                                        checked={attachment.requiredForInternational}
                                                                        onChange={() => this.toggleRequiredForInternational(index)}
                                                                        name="requiredForInternational"
                                                                        style={{ color: '#acd685' }}
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"5%", minWidth: 0}}>
                                                                    <TextField
                                                                        type="number"
                                                                        variant="outlined"
                                                                        size="small"
                                                                        style={{width: "100%"}}
                                                                        name="sequence"
                                                                        value={attachment.sequence ?? ""}
                                                                        onChange={(e) => this.updateSequence(index, e.target.value)}
                                                                        onKeyDown={(e) => ["-", "+", ".", "e", "E"].includes(e.key) && e.preventDefault()}
                                                                        inputProps={{min: 1, step: 1}}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div style={{display: "flex", marginTop: "5px"}}>
                                                                <Tooltip>
                                                                    <IconButton>
                                                                        <RemoveCircleIcon
                                                                            fontSize='small'
                                                                            color='error'
                                                                            visibility="hidden"
                                                                        />

                                                                    </IconButton>
                                                                </Tooltip>
                                                                <div style={{borderRadius: "1px", width:"14%", paddingLeft: "1.8%"}}>
                                                                    <Autocomplete
                                                                        className="ftl-item-shortcode-field"
                                                                        style={{ visibility: "hidden" }}
                                                                        disableCloseOnSelect
                                                                        autoHighlight={true}
                                                                        blurOnSelect={false}
                                                                        renderInput={(params) =>
                                                                            <TextField
                                                                                {...params}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant="outlined"
                                                                                name="shortcodes"
                                                                            />
                                                                        }
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"16%"}}>
                                                                    <Autocomplete
                                                                        className="ftl-item-shortcode-field"
                                                                        autoHighlight={true}
                                                                        style={{ visibility: "hidden" }}
                                                                        renderInput={(params) =>
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                                name="type"
                                                                                InputLabelProps={{ shrink: true }}
                                                                            />
                                                                        }
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"31%"}}>
                                                                    <FileUpload
                                                                        accept="application/pdf"
                                                                        handleFileAdd={(file) => this.handleGeneralFileAdd(file, index)}
                                                                        handleFileDelete={(file, fileIndex) => this.handleGeneralFileDelete(file, fileIndex, index)}
                                                                        files={attachment.file.displayName || attachment.file.path ? [attachment.file] : []}
                                                                        fetchFilePreview={(file) => {
                                                                            this.props.previewFullTruckloadFile({path: file.path, displayName: file.displayName, index: index, type: "Attachment"})
                                                                        }}
                                                                        singleFileUpload={true}
                                                                        isFTL={true}
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"13%"}}>
                                                                    <Autocomplete
                                                                        className="ftl-item-shortcode-field"
                                                                        InputLabelProps={{ shrink: true }}
                                                                        autoHighlight
                                                                        style={{ visibility: "hidden" }}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                variant="outlined"
                                                                                name="signature"
                                                                            />
                                                                        )}
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"7.8%", textAlign: "center"}}>
                                                                    <Checkbox
                                                                        name="requiredForDomestic"
                                                                        style={{ color: '#acd685' ,visibility: "hidden" }}
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"7.8%", textAlign: "center"}}>
                                                                    <Checkbox
                                                                        name="requiredForInternational"
                                                                        style={{ color: '#acd685', visibility: "hidden"}}
                                                                    />
                                                                </div>
                                                                <div style={{borderRadius: "1px", width:"5%", minWidth: 0}}/>
                                                            </div>
                                                        </div>
                                                    }
                                                )
                                            })}
                                        />
                                    </DndProvider>
                                </div>
                            </TableCell>
                        </TableRow>
                        <TableCell style={{ textAlign: "center", border: "none" }}>
                            <Tooltip title={ADD_DOCUMENT}>
                                <IconButton onClick={this.addAttachment}>
                                    <AddCircleIcon
                                        fontSize="small"
                                        color='secondary'
                                    />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </Table>
                    </div>



                    <div className="ftl-stepper-buttons">
                        <Button
                            style={{marginRight: "10px"}}
                            variant='contained'
                            onClick={() => this.props.setCurrentPage(FTL_PAGES.TABLE)}
                        >
                            {CANCEL}
                        </Button>

                        <Button
                            style={{marginLeft: "10px"}}
                            variant='contained'
                            color='primary'
                            onClick={() => {
                                this.saveSettings()
                            }}
                            disabled={!this.state.settingsChanged}
                        >
                            {SAVE}
                        </Button>
                    </div>
                </div>

            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    products: productsSelector(state),
    packages: packagesSelector(state),
    fullTruckloadSettings: fullTruckloadSettingsSelector(state),
    availableLocations: availableLocationsSelector(state),
    signatures: fullTruckloadSignaturesSelector(state),
    suppliers: suppliersSelector(state),
    responseMessage: saveFtlSettingResponseMessageSelector(state)
})

const actionCreators = {
    fetchFullTruckloadSettings,
    listProducts,
    listPackages,
    saveFullTruckloadSettings,
    listAvailableLocations,
    listFullTruckloadSignatures,
    listSuppliers,
    clearFtlSettingSaveResponseMessage
}

export default withShipment({
    mapStateToProps,
    actionCreators,
}, FullTruckloadSetup);